import {createContext, use} from 'react'

export type IssueCreateInitialValuesState = {
  title?: string
  body?: string
  repository?: string
  owner?: string
  template?: string
  labels?: string[]
  assignees?: string[]
  projects?: string[]
  milestone?: string
  issueType?: string
}

const IssueCreateInitialValuesContext = createContext<IssueCreateInitialValuesState | null>(null)

export const useIssueCreateInitialValuesContext = () => {
  const context = use(IssueCreateInitialValuesContext)
  if (!context) {
    return {}
  }

  return context
}
